export default "__VITE_ASSET__b57d524b__"